import { SVGProps } from '.';

export default function DropdownArrowDown(props: SVGProps) {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M3.3333 8.0705 8 12.7372 12.6666 8.0705M8 12.7372V3.4039'
        stroke='#FFFFFF'
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
